export const translationConfig = {
  common: ['CommonUI.Features', 'Common.AlertsAndOptions'],
  feature: 'Feature.ShopDialog'
};

export default translationConfig;
